import { Stack } from "@mui/material";
import { DocumentValidityInfo } from "Components/Users/UserDetailPageContent/Components/RelatedPartyForm/DocumentValidityInfo";
import { AddressesSection } from "Components/Users/UserDetailPageContent/Components/PartyReadOnlyDetail/AddressesSection";
import { DocumentsSection } from "Components/Users/UserDetailPageContent/Components/PartyReadOnlyDetail/DocumentsSection";
import { NaturalPersonSection } from "Components/Users/UserDetailPageContent/Components/PartyReadOnlyDetail/NaturalPersonSection";
import { useCheckPermission } from "Hooks/usePermission";
import { type PartyDto, Permission } from "Infrastructure/Api/Api";
import { AccessRightCodes } from "Models/AccessRightCodes";
import { Resources, useResource } from "Translations/Resources";

type Props = {
  partyData: PartyDto;
};

export const OtherRelationReadOnly = ({ partyData }: Props) => {
  const { t } = useResource();
  const canSeeDocuments = useCheckPermission(
    AccessRightCodes.IDDocuments,
    Permission.Read,
  );
  const genderValue = t(Resources.Form.PersonalData.Sex[partyData.gender]);

  return (
    <Stack gap={4}>
      <NaturalPersonSection party={partyData} genderValue={genderValue} />
      {canSeeDocuments ? (
        <DocumentsSection party={partyData} />
      ) : (
        <DocumentValidityInfo partyData={partyData} />
      )}
      <AddressesSection party={partyData} />
    </Stack>
  );
};
